module.exports = __webpack_public_path__ + "static/media/hangman03.d66ac1a0.svg";